import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  Popup,
  Heading,
  I18n,
  Button,
  TextInput,
  Preloader,
} from 'components';

import { EMAIL_REGEXP } from 'constants/common';

import { formatDateString } from 'utils/formatString';

import { UI_DATE_FORMAT } from '../../constants';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class SendInvoicePopup extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      email: props.email,
      isValid: true,
      sendingError: false,
      sendingSuccess: false,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.props.email !== props.email) {
      this.setState({
        email: props.email,
      });
    }

    if (this.props.isOpened && !props.isOpened) {
      this.setState({
        isValid: true,
        sendingError: false,
        sendingSuccess: false,
      });
    }

    if (this.props.isSending && !props.isSending) {
      this.setState({
        sendingError: !!props.sendingError,
        sendingSuccess: !props.sendingError,
      });
    }
  }

  render() {
    const {
      isOpened,
      closePopup,
      sendInvoice,
      invoiceNumber,
      startDate,
      endDate,
      isSending,
      benNumber,
    } = this.props;

    const {
      email,
      isValid,
      sendingError,
      sendingSuccess,
    } = this.state;

    if (isSending) {
      return (
        <Popup opened={isOpened}>
          <Heading className={cx('title')} level={1}>
            <I18n path="detalization.postpaidInvoices.prepareReportTitle" />
          </Heading>
          <Heading className={cx('subtitle')} level={5}>
            <I18n path="detalization.postpaidInvoices.prepareReportSubtitle" />
          </Heading>
          <Preloader className={cx('preloader')} size="80" />
        </Popup>
      );
    }

    if (sendingError) {
      return (
        <Popup
          opened={isOpened}
          onClose={closePopup}
        >
          <Heading level={1}>
            <I18n path="common.somethingWentWrong" />
          </Heading>
          <Button
            className="big"
            onClick={() => sendInvoice({
              invoiceNumber,
              email,
              benNumber,
            })}
          >
            <I18n path="common.retry" />
          </Button>
        </Popup>
      );
    }

    if (sendingSuccess) {
      return (
        <Popup
          opened={isOpened}
          onClose={closePopup}
        >
          <Heading level={1}>
            <I18n
              path="detalization.postpaidInvoices.reportIsSent"
              vars={{ email }}
            />
          </Heading>
          <Button
            className="big"
            onClick={closePopup}
          >
            <I18n path="common.continueWorking" />
          </Button>
        </Popup>
      );
    }

    return (
      <Popup
        opened={isOpened}
        onClose={closePopup}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            sendInvoice({
              invoiceNumber,
              email,
              benNumber,
            });
          }}
        >
          <Heading className={cx('title')} level={1}>
            <I18n
              path="detalization.postpaidInvoices.invoiceSendingTitle"
              vars={{ invoice: invoiceNumber }}
            />
          </Heading>
          <Heading className={cx('subtitle')} level={5}>
            <I18n
              path="detalization.postpaidInvoices.invoiceSendingSubtitle"
              vars={{
                start: formatDateString(startDate, UI_DATE_FORMAT),
                end: formatDateString(endDate, UI_DATE_FORMAT),
              }}
            />
          </Heading>
          <div className={cx('inputWrapper')}>
            <I18n
              className={cx('inputLabel')}
              path="detalization.postpaidInvoices.emailLabel"
            />
            <div className={cx('textInput')}>
              <TextInput
                className={cx({ fail: !isValid })}
                value={email}
                onChange={(value) => this.setState({
                  email: value,
                  isValid: !value || value.match(EMAIL_REGEXP),
                })}
              />
              {!isValid && (
                <div className={cx('error')}>
                  <I18n path="detalization.postpaidInvoices.invalidEmail" />
                </div>
              )}
            </div>
          </div>
          <Button
            type="submit"
            className={cx('big')}
            disabled={!email || !isValid}
            transformer
          >
            <I18n path="detalization.postpaidInvoices.sendInvoice" />
          </Button>
        </form>
      </Popup>
    );
  }
}

SendInvoicePopup.defaultProps = {
  email: '',
};

SendInvoicePopup.propTypes = {
  isOpened: PropTypes.bool,
  closePopup: PropTypes.func,
  sendInvoice: PropTypes.func,
  invoiceNumber: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  email: PropTypes.string,
  isSending: PropTypes.bool,
  sendingError: PropTypes.string,
  benNumber: PropTypes.number,
};

export default SendInvoicePopup;
